import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { all_routes } from "../../router/all_routes";
import Datatable from "../../../core/common/dataTable";
import Footer from "../../../core/common/Footer";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import { toast } from "react-toastify";
import handleClearError from "../../../core/methods/handleClearError";
import { PaginationType } from "../../../types/common-type";
import {
  parseNumber,
  safeLocaleCompare,
} from "../../../core/methods/sorterMethods";
import ErrorMessage from "../../../core/common/ErrorMessage";
import { useAuth } from "../../../core/context/useAuthContext";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import Loading from "../../../core/common/custom-loading/Loading";
import useLocalStorage from "../../../core/customhook/hooks/useLocalStorage";
import { getSearchableHeader } from "../../../core/utils/getSearchableHeader";
import { exportAntdTableToExcel } from "../../../core/utils/exportExcel";
import { cellWidth } from "../../../core/methods/tableCellWidth";

interface FormDataProp {
  name: string;
  phone: string;
  email: string;
  programs: FilterType[];
}

interface FilterType {
  organization: string;
  project: string;
  location: string;
  program: string;
  department: string;
}

const initialFilter = {
  organization: "",
  project: "",
  location: "",
  program: "",
  department: "",
};

const initialData: FormDataProp = {
  name: "",
  phone: "",
  email: "",
  programs: [],
};

// breadcrumb data
const breadcrumbItem = [{ label: "Add Manager" }];

const AdminAddManager = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { setLocalStorage } = useLocalStorage();

  const [allItemList, setAllItemList] = useState<any[]>([]); //dummydata_managers

  const [formData, setFormData] = useState<FormDataProp>(initialData);
  const [filterData, setFilterData] = useState<FilterType>(initialFilter);
  const [filterLabel, setFilterLabel] = useState<FilterType>(initialFilter);
  const [programListLabel, setProgramListLabel] = useState<FilterType[]>([]);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  const [errors, setErrors] = useState<any>({});
  const [showProgramModal, setShowProgramModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 1000, // limit of records
    total: 0,
  });
  type InviteItem = any;
  const filteredData = (Array.isArray(allItemList) ? allItemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );

  // ---- API ----
  const { callApi, loading, error } = useApi<any>(
    webservice_url.admin_add_manager,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );
  const { callApi: getAllManagerAPI, loading: loading_getManager } =
    useApi<any>(webservice_url.get_all_manager_data, {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    });

  // filterData validation check
  const filtersValidation = () => {
    const newError: any = {};
    const { organization, project, location, program, department } = filterData;

    if (!organization) {
      newError.organization = "Please select organization";
    }
    if (!project) {
      newError.project = "Please select project";
    }
    if (!location) {
      newError.location = "Please select location";
    }
    if (!program) {
      newError.program = "Please select program";
    }
    if (!department) {
      newError.department = "Please select department";
    }
    setErrors(newError);
    return Object.keys(newError).length == 0;
  };

  // Validation check
  const validationCheck = () => {
    const newError: any = {};
    const { name, phone, email, programs } = formData;
    const { organization, project, location, program, department } = filterData;

    if (!name?.trim()) {
      newError.name = "Please enter manager name.";
    }
    if (!email?.trim()) {
      newError.email = "Email is required.";
    }
    if (!phone?.trim()) {
      newError.phone = "Contact number is required.";
    }

    setErrors(newError);
    return Object.keys(newError).length == 0;
  };

  // ---- Columns ----
  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Manager Name",
        "manager_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "manager_name",
      render: (text: string) => (
        <span className="text-capitalize">{text ?? "-"}</span>
      ),
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_name"),
    },
    {
      title: getSearchableHeader(
        "Email",
        "manager_email",
        setInventoryColumnSearch,
      ),
      dataIndex: "manager_email",
      width: 260,
      render: (text: string) => <div className="text-break">{text}</div>,
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_email"),
    },
    {
      title: getSearchableHeader(
        "Contact",
        "manager_phone",
        setInventoryColumnSearch,
      ),
      dataIndex: "manager_phone",
      sorter: (a: any, b: any) =>
        parseNumber(a.manager_phone) - parseNumber(b.manager_phone),
    },
    {
      title: "LOB",
      dataIndex: "programs",
      align: "center",
      render: (text: string, record: any) => {
        return (
          <button
            type="button"
            className="btn btn-sm btn-tertiary py-0"
            onClick={() => {
              // storing in localstorage
              const verifierData = {
                id: record?.manager_id ?? "",
                name: record?.manager_name ?? "",
                email: record?.manager_email ?? "",
                mobile: record?.manager_phone ?? "",
              };
              setLocalStorage("admin_selected_manager", verifierData);

              navigate(
                `${all_routes.manage_manager_programs}/${record.manager_id}`,
              );
              // setShowProgramModal(true)
              // setSelectedItem(record)
            }}
          >
            <i className="ti ti-eye"></i>
          </button>
        );
      },
    },
  ];

  // ======== fetch all managers =========
  const fetchData = async () => {
    try {
      const res = await getAllManagerAPI({
        page: pagination?.current ?? 1,
        limit: pagination?.pageSize ?? 10,
      });
      if (res?.success) {
        const data = res?.data?.rows || [];
        setAllItemList(data);

        setPagination((prev) => ({
          ...prev,
          total: res?.data?.pagination?.totalRecords || 0,
        }));
      }
    } catch (error: any) {
      console.error(error?.response);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.current, pagination?.pageSize]);

  // handleTableChange
  const handleTableChange = (pgConfig: any) => {
    if (
      pgConfig.current !== pagination.current ||
      pgConfig.pageSize !== pagination.pageSize
    ) {
      setPagination((prev) => ({
        ...prev,
        current: pgConfig.current,
        pageSize: pgConfig.pageSize,
      }));
    }
  };
  // ======== / fetch all managers =========

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    handleClearError(setErrors, name);
  };

  // handleAddDepartment
  const handleAddDepartment = () => {
    if (!filtersValidation()) return;

    setFormData((prev) => ({
      ...prev,
      programs: [...prev.programs, filterData],
    }));
    setProgramListLabel((prev) => [...prev, filterLabel]);

    setFilterData(initialFilter);
  };

  // handleLobDelete
  const handleLobDelete = (id: number) => {
    setFormData((prev) => ({
      ...prev,
      programs: prev.programs.filter((_, idx) => idx !== id),
    }));

    setProgramListLabel((prev) => prev.filter((_, idx) => idx !== id));
  };

  // handleCleanUp
  const handleCleanUp = () => {
    setFilterData(initialFilter);
    setFilterLabel(initialFilter);
    setFormData(initialData);
    setProgramListLabel([]);
  };

  // handleAddManager
  const handleAddManager = async () => {
    const isValid = validationCheck();
    if (!isValid) return;

    try {
      const payload = {
        agency_id: auth?.agency_id ?? "",
        agency_user_profile: "MANAGER",
        full_name: formData?.name ?? "",
        email: formData?.email ?? "",
        phone: formData?.phone ?? "",
        programs:
          formData?.programs?.map((p) => ({
            org_id: p?.organization ?? "",
            project_id: p?.project ?? "",
            program_id: p?.program ?? "",
            department_id: p?.department ?? "",
          })) ?? [],
      };
      // console.log("==== payload ====", payload)
      // return;

      const res = await callApi(payload);
      if (res?.success) {
        toast.success(res?.message || "Manager added successfully!");
        handleCleanUp();
        fetchData(); // fetch all managers
      }
    } catch (error: any) {
      console.error(error);
      const errMsg = error?.response?.data?.error || "Something went wrong";
      toast.error(errMsg);
    }
  };

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "All Manager Report",
      sheetName: "All Manager",
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* PageBreadcrumb */}
        <PageBreadcrumb title="Add Manager" breadcrumbs={breadcrumbItem} />
        {/* /PageBreadcrumb */}

        {/* add manager */}
        <div className="card mb-0">
          <div className="card-body pb-3">
            <div className="row gx-3 mb-3 gy-2">
              <div className="col-6 col-md-4">
                <label htmlFor="name" className="form-label">
                  Manger name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control mb-1 text-capitalize"
                  name="name"
                  id="name"
                  value={formData?.name ?? ""}
                  placeholder="Full name"
                  onChange={handleChange}
                />
                <ErrorMessage message={errors?.name} />
              </div>
              <div className="col-6 col-md-4">
                <label htmlFor="email" className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control mb-1"
                  name="email"
                  id="email"
                  value={formData?.email ?? ""}
                  placeholder="you@example.com"
                  onChange={handleChange}
                />
                <ErrorMessage message={errors?.email} />
              </div>
              <div className="col-6 col-md-4">
                <label htmlFor="phone" className="form-label">
                  Contact <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control mb-1"
                  name="phone"
                  value={formData?.phone ?? ""}
                  placeholder="Phone number"
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);

                    setFormData((prev: any) => ({
                      ...prev,
                      phone: value,
                    }));

                    handleClearError(setErrors, "phone");
                  }}
                />
                <ErrorMessage message={errors?.phone} />
              </div>
            </div>

            {/* filters */}
            {/* <DynamicSingleSelect
              fields={[
                "organization",
                "project",
                "location",
                "program",
                "department",
              ]}
              filterData={filterData}
              onFilterDataChange={(name, value, label) => {
                setFilterData((prev) => ({ ...prev, [name]: value }));
                setFilterLabel((prev) => ({ ...prev, [name]: label }));
              }}
              colClass={"col-6 col-sm-3 col-md-3 col-lg-2"}
              parentError={errors}
              showButton={true}
              buttonText="Add"
              onButtonClick={() => {
                handleAddDepartment();
              }}
              disableButton={loading_getManager || loading}
            /> */}
          </div>

          {/* {formData?.programs?.length > 0 && (
            <div className="px-2 mb-3">
              <UserTable
                lobList={programListLabel}
                handleLobDelete={handleLobDelete}
              />
            </div>
          )} */}

          {/* {formData?.programs?.length > 0 && ( */}
          <div className="card-footer  text-end">
            <button
              type="button"
              onClick={handleAddManager}
              className="btn btn-primary py-2"
              disabled={loading_getManager || loading}
              // disabled={loading_getManager || loading || formData?.programs?.length == 0}
              style={{ width: "140px" }}
            >
              {loading ? (
                "Adding..."
              ) : (
                <>
                  <i className="ti ti-plus"></i> Add Manager
                </>
              )}
            </button>
          </div>
          {/* )} */}
        </div>

        {/* Table  */}
        <div className="card mt-3" style={{ minHeight: "250px" }}>
          {loading_getManager ? (
            <Loading />
          ) : (
            <>
              <div className="d-flex justify-content-end pe-2 py-2 pb-0">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleDownloadExcel}
                  disabled={loading}
                >
                  <i className="ti ti-download" /> Export to Excel
                </button>
              </div>
              <Datatable
                rowKey="manager_id"
                dataSource={filteredData}
                fixedHeader
                tableHeight={650}
                columns={columns}
                Selection={false}
                pagination={pagination}
                handleTableChange={handleTableChange}
              />
            </>
          )}
        </div>
      </div>

      {showProgramModal && (
        <ProgramModal
          programs={selectedItem?.programs}
          handleClose={() => setShowProgramModal(false)}
        />
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AdminAddManager;

const ProgramModal = ({
  programs = [],
  handleClose,
}: {
  programs: string[];
  handleClose: () => void;
}) => {
  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="modalTitleId"
        aria-modal="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" style={{ fontSize: "16px" }}>
                Assigned Programs
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              />
            </div>

            <div className="modal-body">
              <div className="row mx-0">
                {programs?.length > 0 ? (
                  programs.map((p, idx) => (
                    <div
                      key={idx}
                      className="col-6 mb-1 p-1 border-botto small"
                    >
                      {idx + 1}. &nbsp; {p}
                    </div>
                  ))
                ) : (
                  <div className="text-muted">No programs assigned</div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn py-1 btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
